import { alpha, Components, Theme } from '@mui/material';

export function getMuiAccordionDetails(
  theme: Theme,
): Components['MuiAccordionDetails'] {
  return {
    styleOverrides: {
      root: {
        fontSize: 14,
        lineHeight: 1.35,
        color: alpha(theme.palette.secondary.contrastText, 0.6),
        padding: 0,
        marginBottom: theme.spacing(4),
      },
    },
  };
}
